export default "__VITE_PUBLIC_ASSET__76a75048__"